import { createFileRoute } from '@tanstack/react-router';

import ClientTransmissionRecordsPage from '../../../../../components/transmissions/ClientTransmissionRecordsPage';
import LoadingPage from '../../../../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/submissions',
)({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: ClientTransmissionRecordsPage,
  staticData: {
    configPageId: 'submissions',
    isClientRoute: true,
    meta: {
      title: 'Client CARF Records | Ledgible',
    },
  },
});
